// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"H5-z","colorTextValue":"I5-z","swatches":"J5-z","collapseLink":"K5-z","isCollapsed":"L5-z","dropdown":"M5-z","disabled":"N5-z"};